var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitRequestIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2295",
    "data-name": "Group 2295",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.174,
    height: 27.174,
    viewBox: "0 0 27.174 27.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M0,0H27.174V27.174H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M16.587,5.4h2.264a2.264,2.264,0,0,1,2.264,2.264v9.25a3.4,3.4,0,1,1-2.264,0V7.661H16.587v3.4l-5.1-4.529L16.587,2ZM5.265,9.733a3.4,3.4,0,1,1,2.264,0v7.178a3.4,3.4,0,1,1-2.264,0ZM6.4,7.661A1.132,1.132,0,1,0,5.265,6.529,1.132,1.132,0,0,0,6.4,7.661Zm0,13.587a1.132,1.132,0,1,0-1.132-1.132A1.132,1.132,0,0,0,6.4,21.248Zm13.587,0a1.132,1.132,0,1,0-1.132-1.132A1.132,1.132,0,0,0,19.984,21.248Z",
    transform: "translate(0.397 0.264)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitRequestIcon);
export default __webpack_public_path__ + "static/media/debit-request-icon.26cd5151e4f17d1a11483cffd55f988c.svg";
export { ForwardRef as ReactComponent };